export let minPoints = 6;
export let minLoad = 120;
export let lastZoom = 999;
export let lastExtent = [42, 42, 42, 42];
export let filterProblems = true;

export function setMinPoints(v) { minPoints = v; }
export function setMinLoad(v) { minLoad = v; }
export function setLastZoom(v) { lastZoom = v; }
export function setLastExtent(v) { lastExtent = v; }
export function setFilterProblems(v) { filterProblems = v; }
